import React, { useState } from "react";
import BANCO, { DOMINIOS, elegirPreguntas } from "../aprende/examen";
import { csv, descargar, guardarJson, leerJson } from "../usuario/util";

// Practica tipo examen: se eligen N preguntas parejas entre los cuatro dominios, se responde una a una y al final hay un resumen por dominio.
const Examen = () => {
    const [fase, setFase] = useState("inicio");     // inicio | pregunta | fin
    const [preguntas, setPreguntas] = useState([]);
    const [i, setI] = useState(0);
    const [resp, setResp] = useState([]);
    const [nombre, setNombre] = useState(() => leerJson("guiaAws.nombre", ""));
    const cambiarNombre = (v) => { setNombre(v); guardarJson("guiaAws.nombre", v); };
    const empezar = (n) => { setPreguntas(elegirPreguntas(BANCO, n)); setResp([]); setI(0); setFase("pregunta"); };
    const q = preguntas[i];
    const elegida = resp[i];
    const aciertos = resp.filter((r, k) => preguntas[k] && r === preguntas[k].c).length;

    if (fase === "inicio") {
        return (
            <div className="card mb-3" style={{ borderTop: "4px solid #8C4FFF" }} data-guia="examen">
                <div className="card-body">
                    <div className="text-muted small mb-1"><i className="fa fa-graduation-cap me-1" />Práctica tipo examen</div>
                    <h4>Prepárate para el nivel «Practitioner»</h4>
                    <p>Preguntas de opción múltiple sobre los cuatro grandes temas: {DOMINIOS.join(", ")}. Al responder verás por qué cada respuesta es correcta.</p>
                    <div className="alert alert-warning py-2 small"><i className="fa fa-exclamation-circle me-1" />Es material de estudio redactado para esta guía. <b>No es el examen oficial</b> ni asegura aprobarlo: revisa la guía oficial del examen de AWS.</div>
                    <label className="form-label small mb-1" htmlFor="examen-nombre">Tu nombre (opcional, para el resultado que puedes descargar)</label>
                    <input id="examen-nombre" className="form-control mb-3" style={{ maxWidth: 360 }} value={nombre} onChange={e => cambiarNombre(e.target.value)} />
                    <div className="d-flex gap-2 flex-wrap">
                        {[10, 15, BANCO.length].map(n => <button key={n} className="btn btn-primary" onClick={() => empezar(n)}>{n === BANCO.length ? `Todas (${n})` : `${n} preguntas`}</button>)}
                    </div>
                </div>
            </div>
        );
    }
    if (fase === "fin") {
        const porDominio = DOMINIOS.map((nombre, d) => {
            const idx = preguntas.map((p, k) => [p, k]).filter(([p]) => p.d === d);
            return { nombre, total: idx.length, ok: idx.filter(([p, k]) => resp[k] === p.c).length };
        }).filter(x => x.total);
        const pct = Math.round((aciertos / preguntas.length) * 100);
        return (
            <div className="card mb-3" style={{ borderTop: "4px solid #8C4FFF" }} data-guia="examen">
                <div className="card-body">
                    <h4>Resultado: {aciertos} de {preguntas.length} ({pct} %)</h4>
                    <p className="text-muted">{pct >= 70 ? "¡Buen resultado! Repasa las que fallaste para afirmarlas." : "Sigue practicando: repasa las rutas de aprendizaje y vuelve a intentarlo."}</p>
                    <ul className="list-unstyled">
                        {porDominio.map(x => (
                            <li key={x.nombre} className="mb-2"><div className="d-flex justify-content-between small"><span>{x.nombre}</span><span>{x.ok} de {x.total}</span></div>
                                <div className="progress" style={{ height: 8 }}><div className="progress-bar bg-success" style={{ width: `${(x.ok / x.total) * 100}%` }} /></div></li>
                        ))}
                    </ul>
                    <div className="fw-bold mb-1">Preguntas que fallaste</div>
                    {preguntas.every((p, k) => resp[k] === p.c) ? <div className="text-success">Ninguna: ¡todas correctas!</div> : (
                        <ul className="small">{preguntas.map((p, k) => resp[k] !== p.c && <li key={k} className="mb-1"><b>{p.p}</b> → {p.o[p.c]}. {p.e}</li>)}</ul>
                    )}
                    <button className="btn btn-primary mt-2 me-2" onClick={() => setFase("inicio")}>Practicar de nuevo</button>
                    <button className="btn btn-outline-secondary mt-2" onClick={() => descargar("resultado-examen-aws.csv", csv([["Nombre", "Fecha", "Aciertos", "Preguntas", "Porcentaje", ...porDominio.map(x => x.nombre)], [nombre || "", new Date().toLocaleString("es-CL"), aciertos, preguntas.length, pct, ...porDominio.map(x => `${x.ok} de ${x.total}`)]]), "text/csv;charset=utf-8")}><i className="fa fa-file-csv me-1" />Descargar resultado</button>
                </div>
            </div>
        );
    }
    return (
        <div className="card mb-3" style={{ borderTop: "4px solid #8C4FFF" }} data-guia="examen">
            <div className="card-body">
                <div className="d-flex align-items-center mb-1"><div className="text-muted small me-auto">{DOMINIOS[q.d]} · pregunta {i + 1} de {preguntas.length}</div><span className="badge text-bg-light">Aciertos: {aciertos}</span></div>
                <div className="progress mb-3" style={{ height: 6 }}><div className="progress-bar" style={{ width: `${(i / preguntas.length) * 100}%` }} /></div>
                <h5 className="mb-3">{q.p}</h5>
                <div className="d-grid gap-2">
                    {q.o.map((op, k) => {
                        const ok = elegida != null && k === q.c, mal = elegida === k && k !== q.c;
                        return <button key={k} className={`btn text-start ${ok ? "btn-success" : mal ? "btn-danger" : "btn-outline-secondary"}`} disabled={elegida != null && !ok && !mal} onClick={() => elegida == null && setResp(r => { const n = [...r]; n[i] = k; return n; })}>{ok && <i className="fa fa-check me-2" />}{mal && <i className="fa fa-times me-2" />}{op}</button>;
                    })}
                </div>
                {elegida != null && (
                    <div className={`alert ${elegida === q.c ? "alert-success" : "alert-warning"} py-2 mt-3 mb-0`}><b>{elegida === q.c ? "¡Correcto!" : "Incorrecto."}</b> {q.e}</div>
                )}
                <div className="d-flex justify-content-end mt-3">
                    <button className="btn btn-primary" disabled={elegida == null} onClick={() => (i + 1 < preguntas.length ? setI(i + 1) : setFase("fin"))}>{i + 1 < preguntas.length ? "Siguiente" : "Ver resultado"}<i className="fa fa-chevron-right ms-1" /></button>
                </div>
            </div>
        </div>
    );
};

export default Examen;
